export default __webpack_public_path__ + "252a15e0bc0dff9891aab785d28945e0.png";